var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BN from 'bn.js';
import { tickerPrice } from './utils';
/// A value bearing asset, existing in some blockchain system.
export class Asset {
    constructor(asset) {
        this.name = asset.name;
        this.ticker = asset.ticker;
        this.amount = asset.amount;
        this.transferrable = asset.transferrable;
        this.amount = asset.amount;
        this.price = asset.price;
        this.decimals = asset.decimals;
        this.origin = asset.origin;
    }
    /// Refresh the price of this asset. Updated `this.price`.
    refreshPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            this.price = yield tickerPrice(this.ticker);
        });
    }
    // the decimal part of the amount, e.g. `123` in `123.xxx`
    decimal() {
        return this.amount.div(new BN(10).pow(this.decimals));
    }
    // the (per-thousand) fractional part of the amount, e.g. `123` in `x.123`
    fraction() {
        return this.amount.div(new BN(10).pow(this.decimals.sub(new BN(3)))).mod(new BN(1000));
    }
    // combination of `decimal` and `fraction`, returned as a float number.
    floatAmount() {
        return parseFloat(`${this.decimal()}.${this.fraction().toString()}`);
    }
    euroValue() {
        if (this.price === 0) {
            return 0;
        }
        const d = new BN(1000);
        const scaledValue = this.amount.mul(d).div(new BN(10).pow(this.decimals)).toNumber();
        return (scaledValue * this.price) / 1000;
    }
}
